import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import "./App.css";
import About from "./component/About";
import Footer from "./component/Footer";
import Header from "./component/Header";
import Home from "./component/Home";
import MediaComp from "./component/MediaComp";
import Career from "./component/Career";
import Industry from "./component/Industry";
import Contact from "./component/Contact";
import BeSpoke from "./component/BeSpoke";
import StaffAug from "./component/StaffAug";
import SasProduct from "./component/SasProduct";
import ManagedItServices from "./component/ManagedItServices";
import Book from "./component/Book";
import Blog from "./component/Blog";
import BlogDetail from "./component/BlogDetail";
import CaseStudies from "./component/CaseStudies";
import CaseStudyDetail from "./component/CaseStudyDetail";
import Privacy from "./component/Privacy";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    // Refresh AOS animations on route transitions
    if (window.AOS) {
      window.AOS.refresh();
    }

    // Update canonical link tag for SEO
    let canonicalLink = document.querySelector("link[rel='canonical']");
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    
    // Clean up index.html or trailing slashes
    let cleanPath = pathname;
    if (cleanPath === "/index.html") {
      cleanPath = "/";
    }
    if (cleanPath.length > 1 && cleanPath.endsWith("/")) {
      cleanPath = cleanPath.slice(0, -1);
    }
    
    canonicalLink.setAttribute("href", `https://tedekstra.com${cleanPath}`);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/index.html" element={<Navigate to="/" replace />} />
        <Route path="/about" element={<About />} />
        <Route path="/media" element={<MediaComp />} />
        <Route path="/career" element={<Career />} />
        <Route path="/industries" element={<Industry />} />
        <Route path="/be-spoke" element={<BeSpoke />} />
        <Route path="/staff-augmentation" element={<StaffAug />} />
        <Route path="/saas-products" element={<SasProduct />} />
        <Route path="/managed-services" element={<ManagedItServices />} />
        <Route path="/book" element={<Book />} />
        <Route path="/blog-detail" element={<BlogDetail />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
        <Route path="/case-study/:slug" element={<CaseStudyDetail />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
